<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Detalhamento" exibeVoltar="true" historyback="true"/>
        </div>
		<div class="app-centro-sem-rodape">
            <table class="table" cellpadding="4" cellspacing="0" align="center">

                <tr style="height: 40px;">
                    <th align="center" width="70%"><b>Conta</b></th>
                    <th align="center" width="30%"><b>Valor</b></th>
                </tr>

                <tbody  v-for="item in detcpcr" v-bind:key="item.DATA_VCT">
                    <tr>
                        <td>{{ item.DESC_CONTA }}</td>
                        <td align="right">{{ item.SUM_SALDO | toCurrency }}</td>
                    </tr>
                </tbody>

                <tr>
                    <td align="right"><b>Total:</b></td>
                    <td align="right"><b>{{ total | toCurrency }}</b></td>
                </tr>

            </table>      
        </div>
	</div>

</template>


<script>


import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';


export default {
    name:   'DetalhamentoCPCR',
    props: ['tipo','dt'],
    components: {TopBar},

    data(){
        return {
            detcpcr:[]
        }        
    },

    mounted: function () {

        request(this, 'GET',
            'Mobile_Detalhe_CP_CR',
            `tipo=${this.tipo}&dt=${this.dt}&rootProperty=detcpcr`)
        .then(res => {
            if(res){
                this.detcpcr=res.detcpcr;
            }
        });

    },
    computed : {
        total: function() {

            if(this.detcpcr.length){
                return this.detcpcr.reduce((sum, item) => sum + item.SUM_SALDO, 0);
            } else {
                return 0;
            }
        }
    }
}
</script>


<style scoped>
    .table{
        border-collapse: collapse;
        width: calc(100% - 20px);
        margin: 20px 10px;    
        border: 1px solid var(--dark-color);    
    }

    td{
        --border-collapse: collapse;
        border: 1px solid var(--dark-color);
    }

    th{
        

        border: 1px solid var(--dark-color);
        background-color: var(--primary-color);
        color: white;

    }
</style>